import styles from './MarkdownEditor.module.css';
import { MouseEventHandler } from 'react';

interface ILabelWrapperProps {
  children: any;
  onClick?: MouseEventHandler<HTMLElement>;
}

export function LabelWrapper({ children, onClick }: ILabelWrapperProps) {
  return (
    // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
    <label htmlFor="markdown-editor" onClick={onClick} className={styles['editor-label-wrapper']}>
      {children}
    </label>
  );
}
